<template>
    <div class="panel-offline">
        <h1>{{ $t('twitch.globalMsg.offline') }}</h1>
    </div>
</template>

<script>
export default {
    name: 'PanelOffline',
};
</script>

<style src="./PanelOffline.scss" lang="scss" scoped></style>
